<div
  class="rowFlexNoWrap"
  style="flex-wrap: nowrap; height: 90px; position: relative"
>
  <button
    mat-button
    mat-dialog-close
    class="close-button"
    style="
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 1000;
      margin-left: 0;
    "
  >
    <img
      src="../../../assets/icons/cerrar.png"
      alt="Cerrar"
      style="height: 30px; width: 30px"
    />
  </button>

  <!-- dias -->
  <div style="width: 20%; min-width: 180px">
    <div class="cardContainer">
      <div class="card">
        <div
          class="rowFlexNoWrap"
          style="justify-content: space-evenly; width: 100%"
        >
          <div>
            <span><strong>Dia Inicio</strong></span>
          </div>
          <div>&nbsp;</div>
          <div>
            <span><strong>Dia Fin</strong></span>
          </div>
        </div>
        <div class="rowFlexNoWrap rowInputs">
          <input type="number" [(ngModel)]="minTiempoProceso" disabled />
          <span><strong>-</strong></span>
          <input type="number" [(ngModel)]="maxTiempoProceso" disabled />
        </div>
      </div>
    </div>
  </div>

  <!-- moneda y medida -->
  <div class="spacer" style="width: 10%; min-width: 180px">
    <div class="rowFlexNoWrapCenter" style="">
      <div class="switchWithIcons" style="">
        <button
          class="button"
          [ngClass]="{ btnSwitchIconON: switch1, btnSwitchIconOff: !switch1 }"
          (click)="EventChangeUsdVol()"
        >
          <img
            src="../../../assets/icons/bolsa.png"
            alt="Alternate Text"
            title="USD"
          />
        </button>
        <button
          class="button"
          [ngClass]="{ btnSwitchIconON: !switch1, btnSwitchIconOff: switch1 }"
          (click)="EventChangeUsdVol()"
        >
          <img
            src="../../../assets/icons/tonelada1.png"
            alt="Alternate Text"
            title="Toneldas"
          />
        </button>
      </div>
    </div>
  </div>

  <div
    style="
      flex: 1;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      pointer-events: none;
    "
  >
    <h2 style="margin: 0; display: inline-block; pointer-events: auto">
      {{ data.paisSitio }}
    </h2>
  </div>
</div>

<div class="containerGraph" style="">
  <div class="rowText" style="">
    <strong>{{ data.PlantillaSelected?.Nombre }}</strong>
  </div>

  <div
    #graph
    id="graph"
    [chart]="chart"
    style="width: 100%; padding-left: 50px; padding-right: 10px"
  ></div>

  <div class="flexRowNoWrap rowText">
    <div class="rowFlexNoWrapCenter" style="">
      <div class="switchWithIcons" style="width: 170px; height: 40px">
        <button
          class="button"
          style="height: 30px"
          [ngClass]="{
            btnSwitchIconON: switchUsdGestion,
            btnSwitchIconOff: !switchUsdGestion
          }"
          (click)="switchUsdGestion = !switchUsdGestion"
        >
          <!--<img src="../../../assets/icons/tabla.png" alt="Alternate Text" />-->
          <strong>USD</strong>
        </button>
        <button
          class="button"
          style="height: 30px"
          [ngClass]="{
            btnSwitchIconON: !switchUsdGestion,
            btnSwitchIconOff: switchUsdGestion
          }"
          (click)="switchUsdGestion = !switchUsdGestion"
        >
          <!--<img src="../../../assets/icons/graph.png" alt="Alternate Text" />-->
          <strong>Gestión</strong>
        </button>
      </div>
      <button
        class="button primary"
        mat-button
        color="primary"
        (click)="MostrarCostosLogisticos()"
        style="margin-left: 20px"
      >
        <img src="../../../assets/icons/plus.png" alt="Alternate Text" />
        Costos Logístico
      </button>
      <!-- Filtros SKU, Origen, Destino, País Destino -->

      <div
        *ngIf="mostrarFiltros"
        class="rowFlexNoWrapCenter"
        style="
          justify-content: flex-start;
          align-items: center;
          margin-left: 20px;
        "
      >
        <div
          class="switchWithIcons"
          [style.width]="ocultarPaisDestino ? '200px' : '270px'"
          style="height: 40px"
        >
          <!-- Botón Filtro SKU -->
          <button
            class="button"
            style="height: 30px"
            [ngClass]="{
              btnSwitchIconON: esFiltroActivo('sku'),
              btnSwitchIconOff: !esFiltroActivo('sku')
            }"
            (click)="activarFiltro('sku')"
          >
            <strong>SKU</strong>
          </button>

          <!-- Botón Filtro Origen -->
          <button
            class="button"
            style="height: 30px"
            [ngClass]="{
              btnSwitchIconON: esFiltroActivo('origen'),
              btnSwitchIconOff: !esFiltroActivo('origen')
            }"
            (click)="activarFiltro('origen')"
          >
            <strong>Origen</strong>
          </button>

          <!-- Botón Filtro Destino (solo visible si ocultarPaisDestino es false) -->
          <button
            *ngIf="!ocultarPaisDestino"
            class="button"
            style="height: 30px"
            [ngClass]="{
              btnSwitchIconON: esFiltroActivo('destino'),
              btnSwitchIconOff: !esFiltroActivo('destino')
            }"
            (click)="activarFiltro('destino')"
          >
            <strong>Destino</strong>
          </button>

          <!-- Botón Filtro País Destino -->
          <!-- <button
      class="button"
      style="height: 30px"
      [ngClass]="{
        btnSwitchIconON: esFiltroActivo('paisDestino'),
        btnSwitchIconOff: !esFiltroActivo('paisDestino')
      }"
      (click)="activarFiltro('paisDestino')"
    >
      <strong>País Destino</strong>
    </button> -->
        </div>
      </div>
    </div>

    <div class="rowFlexNoWrapCenter" style="margin-left: auto">
      <div class="switchWithIcons" style="width: 170px; height: 40px">
        <button
          class="button"
          style="height: 30px"
          [ngClass]="{
            btnSwitchIconON: switchTablaOrGraph,
            btnSwitchIconOff: !switchTablaOrGraph
          }"
          (click)="
            switchTablaOrGraph = !switchTablaOrGraph; EventChangeTableOrGraph()
          "
        >
          <img src="../../../assets/icons/tabla.png" alt="Alternate Text" />
          Tabla
        </button>
        <button
          class="button"
          style="height: 30px"
          [ngClass]="{
            btnSwitchIconON: !switchTablaOrGraph,
            btnSwitchIconOff: switchTablaOrGraph
          }"
          (click)="
            switchTablaOrGraph = !switchTablaOrGraph; EventChangeTableOrGraph()
          "
        >
          <img src="../../../assets/icons/graph.png" alt="Alternate Text" />
          Gráfico
        </button>
      </div>
    </div>
  </div>

  <!--************GRID***********-->

  <div class="SectionGrids">
    <div style="">
      <!--************Encabezado***********-->

      <div
        class="flexRowNoWrap EncabezadoGridR1"
        style="justify-content: space-between; flex-wrap: nowrap"
      >
        <div class="cellListP" style="width: 40px; min-width: 40px">
          <div class="cellListE1">&nbsp;</div>
        </div>

        <div
          class="cellListP"
          style="width: 100px; min-width: 100px"
          [ngStyle]="{ 'min-width': switchUsdGestion ? '100px' : '200px' }"
        >
          <div class="cellListE1"><span>Volumen</span></div>
        </div>

        <div
          *ngIf="switchUsdGestion"
          class="cellListP"
          style="width: 100px; min-width: 100px"
        >
          <div class="cellListE1"><span>USD</span></div>
        </div>

        <div class="cellListP">
          <div class="cellListE1"><span>Orígen</span></div>
        </div>

        <div class="cellListP">
          <div class="cellListE1"><span>Tránsito 1</span></div>
        </div>

        <div class="cellListP">
          <div class="cellListE1"><span>Frontera</span></div>
        </div>

        <div class="cellListP">
          <div class="cellListE1"><span>Transito 2</span></div>
        </div>

        <div class="cellListP">
          <div class="cellListE1"><span>Destino</span></div>
        </div>
      </div>
    </div>
    <!--************Body grids***********-->
    <div>
      <div class="subsection" style="">
        <div *ngFor="let item of listCostosFactura; let i = index">
          <div class="flexRowNoWrap rowGrid">
            <div class="cellListP" style="width: 40px; min-width: 40px">
              <div
                class="cellListE1 c-pointer"
                (click)="
                  item.Expandible = !item.Expandible; EventChangeTableOrGraph()
                "
              >
                <img
                  *ngIf="!item.Expandible"
                  src="../../../assets/icons/arrowDownBlack1.png"
                  alt="Alternate Text"
                />
                <img
                  *ngIf="item.Expandible"
                  src="../../../assets/icons/arrowUpBlack1.png"
                  alt="Alternate Text"
                />
              </div>
            </div>

            <div
              class="cellListP cursor c-pointer"
              style="width: 100px; min-width: 100px"
              (click)="EventModalGestiones('all')"
              [ngStyle]="{ 'min-width': switchUsdGestion ? '100px' : '200px' }"
            >
              <div class="cellListE1">
                <span>{{ item.Volumen | commaDecimal }}</span>
              </div>
            </div>

            <div
              *ngIf="switchUsdGestion"
              class="cellListP"
              style="width: 100px; min-width: 100px"
            >
              <div class="cellListE1">
                <span>${{ item.USD | commaDecimal }}</span>
              </div>
            </div>

            <div
              class="cellListP cursor c-pointer"
              style=""
              (click)="EventModalGestiones('Origen')"
            >
              <div *ngIf="switchUsdGestion" class="cellListE1">
                <span>${{ item.Origen | commaDecimal }}</span>
              </div>
              <div *ngIf="!switchUsdGestion" class="cellListE1">
                <span>{{ item.OrigenGestiones }}</span>
              </div>
            </div>

            <div
              class="cellListP cursor c-pointer"
              style=""
              (click)="EventModalGestiones('TransitoUno')"
            >
              <div *ngIf="switchUsdGestion" class="cellListE1">
                <span>${{ item.TransitoUno | commaDecimal }}</span>
              </div>
              <div *ngIf="!switchUsdGestion" class="cellListE1">
                <span>{{ item.TransitoUnoGestiones }}</span>
              </div>
            </div>

            <div
              class="cellListP cursor c-pointer"
              style=""
              (click)="EventModalGestiones('Frontera')"
            >
              <div *ngIf="switchUsdGestion" class="cellListE1">
                <span>${{ item.Frontera | commaDecimal }}</span>
              </div>
              <div *ngIf="!switchUsdGestion" class="cellListE1">
                <span>{{ item.FronteraGestiones }}</span>
              </div>
            </div>

            <div
              class="cellListP cursor c-pointer"
              style=""
              (click)="EventModalGestiones('TransitoDos')"
            >
              <div *ngIf="switchUsdGestion" class="cellListE1">
                <span>${{ item.TransitoDos | commaDecimal }}</span>
              </div>
              <div *ngIf="!switchUsdGestion" class="cellListE1">
                <span>{{ item.TransitoDosGestiones }}</span>
              </div>
            </div>

            <div
              class="cellListP cursor c-pointer"
              style=""
              (click)="EventModalGestiones('Destino')"
            >
              <div *ngIf="switchUsdGestion" class="cellListE1">
                <span>${{ item.Destino | commaDecimal }}</span>
              </div>
              <div *ngIf="!switchUsdGestion" class="cellListE1">
                <span>{{ item.DestinoGestiones }}</span>
              </div>
            </div>
          </div>

          <div
            *ngIf="switchTablaOrGraph && item.Expandible"
            style="margin-top: 20px"
          >
            <div
              *ngIf="item.Expandible && esFiltroActivo('sku')"
              class="SectionGrids"
            >
              <div style="">
                <!--************Encabezado***********-->
                <div
                  class="flexRowNoWrap EncabezadoGridR1"
                  style="justify-content: space-between; flex-wrap: nowrap"
                >
                  <div class="cellListP" style="width: 40px; min-width: 40px">
                    <div class="cellListE1">&nbsp;</div>
                  </div>

                  <div
                    class="cellListP"
                    style="width: 100px; min-width: 100px"
                    [ngStyle]="{
                      'min-width': switchUsdGestion ? '100px' : '200px'
                    }"
                  >
                    <div class="cellListE1"><span>Categoria</span></div>
                  </div>

                  <div
                    *ngIf="switchUsdGestion"
                    class="cellListP"
                    style="width: 100px; min-width: 100px"
                  >
                    <div class="cellListE1"><span>USD</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Orígen</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Tránsito 1</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Frontera</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Transito 2</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Destino</span></div>
                  </div>
                </div>
              </div>

              <!--************Body grids***********-->

              <div>
                <div class="subsection" style="">
                  <div
                    *ngFor="let categoria of item.ListCategorys; let i = index"
                  >
                    <div class="flexRowNoWrap rowGrid">
                      <div
                        class="cellListP"
                        style="width: 40px; min-width: 40px"
                      >
                        <div
                          class="cellListE1 c-pointer"
                          (click)="categoria.Expandible = !categoria.Expandible"
                        >
                          <img
                            *ngIf="!categoria.Expandible"
                            src="../../../assets/icons/arrowDownBlack1.png"
                            alt="Alternate Text"
                          />
                          <img
                            *ngIf="categoria.Expandible"
                            src="../../../assets/icons/arrowUpBlack1.png"
                            alt="Alternate Text"
                          />
                        </div>
                      </div>

                      <div
                        class="cellListP"
                        style="width: 100px; min-width: 100px"
                        [ngStyle]="{
                          'min-width': switchUsdGestion ? '100px' : '200px'
                        }"
                      >
                        <div class="cellListE1">
                          <span>{{ categoria.Categoria }}</span>
                        </div>
                      </div>

                      <div
                        *ngIf="switchUsdGestion"
                        class="cellListP"
                        style="width: 100px; min-width: 100px"
                      >
                        <div class="cellListE1">
                          <span>${{ categoria.USD | commaDecimal }}</span>
                        </div>
                      </div>

                      <div class="cellListP" style="">
                        <div *ngIf="switchUsdGestion" class="cellListE1">
                          <span>${{ categoria.Origen | commaDecimal }}</span>
                        </div>
                        <div
                          *ngIf="!switchUsdGestion"
                          class="cellListE1 cursor c-pointer"
                          (click)="
                            eventModalGestionesCategoriasFiltros(
                              'Origen',
                              categoria.Categoria
                            )
                          "
                        >
                          <span>{{ categoria.OrigenGestiones }}</span>
                        </div>
                      </div>

                      <div class="cellListP" style="">
                        <div *ngIf="switchUsdGestion" class="cellListE1">
                          <span
                            >${{ categoria.TransitoUno | commaDecimal }}</span
                          >
                        </div>
                        <div
                          *ngIf="!switchUsdGestion"
                          class="cellListE1 cursor c-pointer"
                          (click)="
                            eventModalGestionesCategoriasFiltros(
                              'TransitoUno',
                              categoria.Categoria
                            )
                          "
                        >
                          <span>{{ categoria.TransitoUnoGestiones }}</span>
                        </div>
                      </div>

                      <div class="cellListP" style="">
                        <div *ngIf="switchUsdGestion" class="cellListE1">
                          <span>${{ categoria.Frontera | commaDecimal }}</span>
                        </div>
                        <div
                          *ngIf="!switchUsdGestion"
                          class="cellListE1 cursor c-pointer"
                          (click)="
                            eventModalGestionesCategoriasFiltros(
                              'Frontera',
                              categoria.Categoria
                            )
                          "
                        >
                          <span>{{ categoria.FronteraGestiones }}</span>
                        </div>
                      </div>

                      <div class="cellListP" style="">
                        <div *ngIf="switchUsdGestion" class="cellListE1">
                          <span
                            >${{ categoria.TransitoDos | commaDecimal }}</span
                          >
                        </div>
                        <div
                          *ngIf="!switchUsdGestion"
                          class="cellListE1 cursor c-pointer"
                          (click)="
                            eventModalGestionesCategoriasFiltros(
                              'TransitoDos',
                              categoria.Categoria
                            )
                          "
                        >
                          <span>{{ categoria.TransitoDosGestiones }}</span>
                        </div>
                      </div>

                      <div class="cellListP" style="">
                        <div *ngIf="switchUsdGestion" class="cellListE1">
                          <span>${{ categoria.Destino | commaDecimal }}</span>
                        </div>
                        <div
                          *ngIf="!switchUsdGestion"
                          class="cellListE1 cursor c-pointer"
                          (click)="
                            eventModalGestionesCategoriasFiltros(
                              'Destino',
                              categoria.Categoria
                            )
                          "
                        >
                          <span>{{ categoria.DestinoGestiones }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- sku -->
                    <div *ngIf="categoria.Expandible" class="SectionGrids">
                      <!--************Body grids***********-->
                      <div>
                        <div class="subsection" style="">
                          <div
                            *ngFor="
                              let skus of categoria.Listdos;
                              let i = index
                            "
                          >
                            <div class="flexRowNoWrap rowGrid">
                              <!--<div class="cellListP " style=" width: 40px; min-width: 40px;">
                                <div class="cellListE1 " (click)="categoria.Expandible = !categoria.Expandible">
                                  <img *ngIf="!categoria.Expandible" src="../../../assets/icons/arrowDownBlack1.png" alt="Alternate Text" />
                                  <img *ngIf="categoria.Expandible" src="../../../assets/icons/arrowUpBlack1.png" alt="Alternate Text" />
                                </div>
                              </div>-->

                              <div
                                class="cellListP"
                                style="width: 40px; min-width: 40px"
                              >
                                <div class="cellListE1">&nbsp;</div>
                              </div>

                              <div
                                class="cellListP"
                                style="width: 100px; min-width: 100px"
                                [ngStyle]="{
                                  'min-width': switchUsdGestion
                                    ? '100px'
                                    : '200px'
                                }"
                              >
                                <div class="cellListE1">
                                  <span>{{ skus.Descripcion }}</span>
                                </div>
                              </div>

                              <div
                                *ngIf="switchUsdGestion"
                                class="cellListP"
                                style="width: 100px; min-width: 100px"
                              >
                                <div class="cellListE1">
                                  <span>${{ skus.USD | commaDecimal }}</span>
                                </div>
                              </div>

                              <div class="cellListP" style="">
                                <div
                                  *ngIf="switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span>${{ skus.Origen | commaDecimal }}</span>
                                </div>
                                <div
                                  *ngIf="!switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span>{{ skus.OrigenGestiones }}</span>
                                </div>
                              </div>

                              <div class="cellListP" style="">
                                <div
                                  *ngIf="switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span
                                    >${{
                                      skus.TransitoUno | commaDecimal
                                    }}</span
                                  >
                                </div>
                                <div
                                  *ngIf="!switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span>{{ skus.TransitoUnoGestiones }}</span>
                                </div>
                              </div>

                              <div class="cellListP" style="">
                                <div
                                  *ngIf="switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span
                                    >${{ skus.Frontera | commaDecimal }}</span
                                  >
                                </div>
                                <div
                                  *ngIf="!switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span>{{ skus.FronteraGestiones }}</span>
                                </div>
                              </div>

                              <div class="cellListP" style="">
                                <div
                                  *ngIf="switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span
                                    >${{
                                      skus.TransitoDos | commaDecimal
                                    }}</span
                                  >
                                </div>
                                <div
                                  *ngIf="!switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span>{{ skus.TransitoDosGestiones }}</span>
                                </div>
                              </div>

                              <div class="cellListP" style="">
                                <div
                                  *ngIf="switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span
                                    >${{ skus.Destino | commaDecimal }}</span
                                  >
                                </div>
                                <div
                                  *ngIf="!switchUsdGestion"
                                  class="cellListE1"
                                >
                                  <span>{{ skus.DestinoGestiones }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--************Filtro de Origen***********-->

            <div
              *ngIf="item.Expandible && esFiltroActivo('origen')"
              class="SectionGrids"
            >
              <div style="">
                <!--************Encabezado***********-->
                <div
                  class="flexRowNoWrap EncabezadoGridR1"
                  style="justify-content: space-between; flex-wrap: nowrap"
                >
                  <div class="cellListP" style="width: 40px; min-width: 40px">
                    <div class="cellListE1">&nbsp;</div>
                  </div>

                  <div class="cellListP" style="width: 100px; min-width: 200px">
                    <div class="cellListE1"><span>Sitio Origen</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Orígen</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Tránsito 1</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Frontera</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Transito 2</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Destino</span></div>
                  </div>
                </div>
              </div>

              <!--************Body grids***********-->
              <div>
                <div class="subsection">
                  <div *ngFor="let sitio of listOrigen; let i = index">
                    <div class="flexRowNoWrap rowGrid">
                      <div
                        class="cellListP"
                        style="width: 40px; min-width: 40px"
                      >
                        <div class="cellListE1">&nbsp;</div>
                      </div>
                      <!-- NombreRuta -->
                      <div
                        class="cellListP"
                        style="width: 100px; min-width: 200px"
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.NombreRuta }}</span>
                        </div>
                      </div>
                      <!-- Origen -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesOrigenFiltros(
                            'Origen',
                            'Origen',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.Origen }}</span>
                        </div>
                      </div>

                      <!-- Transito 1 -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesOrigenFiltros(
                            'TransitoUno',
                            'Origen',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.TransitoUno }}</span>
                        </div>
                      </div>

                      <!-- Frontera -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesOrigenFiltros(
                            'Frontera',
                            'Origen',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.Frontera }}</span>
                        </div>
                      </div>

                      <!-- Transito 2 -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesOrigenFiltros(
                            'TransitoDos',
                            'Origen',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.TransitoDos }}</span>
                        </div>
                      </div>

                      <!-- Destino -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesOrigenFiltros(
                            'Destino',
                            'Origen',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.Destino }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--************Filtro de Destino***********-->

            <div
              *ngIf="item.Expandible && esFiltroActivo('destino')"
              class="SectionGrids"
            >
              <div style="">
                <!--************Encabezado***********-->
                <div
                  class="flexRowNoWrap EncabezadoGridR1"
                  style="justify-content: space-between; flex-wrap: nowrap"
                >
                  <div class="cellListP" style="width: 40px; min-width: 40px">
                    <div class="cellListE1">&nbsp;</div>
                  </div>

                  <div class="cellListP" style="width: 100px; min-width: 200px">
                    <div class="cellListE1"><span>Sitio Destino</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Orígen</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Tránsito 1</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Frontera</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Transito 2</span></div>
                  </div>

                  <div class="cellListP">
                    <div class="cellListE1"><span>Destino</span></div>
                  </div>
                </div>
              </div>

              <!--************Body grids***********-->
              <div>
                <div class="subsection">
                  <div *ngFor="let sitio of listDestino; let i = index">
                    <div class="flexRowNoWrap rowGrid">
                      <div
                        class="cellListP"
                        style="width: 40px; min-width: 40px"
                      >
                        <div class="cellListE1">&nbsp;</div>
                      </div>
                      <!-- NombreRuta -->
                      <div
                        class="cellListP"
                        style="width: 100px; min-width: 200px"
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.NombreRuta }}</span>
                        </div>
                      </div>
                      <!-- Origen -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesDestinoFiltros(
                            'Origen',
                            'Destino',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.Origen }}</span>
                        </div>
                      </div>

                      <!-- Transito 1 -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesDestinoFiltros(
                            'TransitoUno',
                            'Destino',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.TransitoUno }}</span>
                        </div>
                      </div>

                      <!-- Frontera -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesDestinoFiltros(
                            'Frontera',
                            'Destino',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.Frontera }}</span>
                        </div>
                      </div>

                      <!-- Transito 2 -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesDestinoFiltros(
                            'TransitoDos',
                            'Destino',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.TransitoDos }}</span>
                        </div>
                      </div>

                      <!-- Destino -->
                      <div
                        class="cellListP cursor c-pointer"
                        (click)="
                          eventModalGestionesDestinoFiltros(
                            'Destino',
                            'Destino',
                            sitio
                          )
                        "
                      >
                        <div class="cellListE1">
                          <span>{{ sitio.Destino }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!switchTablaOrGraph && item.Expandible">
            <!--*****Cuando se cambia el switch a Grafica-->
            <div class="SectionGrids">
              <graph-grid-switch
                #graphCalorInfo
                [dataGestiones]="dataGestiones"
              ></graph-grid-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
